import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import { useFeatureFlag } from '@fs/zion-flags'

export default function useThirdPartyAccessLinks({
  canSeeTemple,
  isNonEnCoreLanguage,
  isCoreLanguage,
  canAddPersonalData,
}) {
  const { t } = useTranslation()
  const thirdPartyAccessLinksIsOn = useFeatureFlag('home_fatFooter_thirdPartyAccessLinks').isOn

  return {
    id: 'thirdPartyAccess',
    title: t('nav.third-party-access', 'Third-party Access'),
    nonReligiousmode: null,
    hidden: !canAddPersonalData || !isCoreLanguage || !thirdPartyAccessLinksIsOn,
    subNav: [
      {
        id: 'ancestry',
        text: t('nav.links.third-party-access.ancestry', 'Ancestry'),
        url: `/${i18n.language}/access/ancestry`,
        linkName: 'ff_thirdParty_ancestry',
        isNew: false,
      },
      {
        id: 'myHeritage',
        text: t('nav.links.third-party-access.myheritage', 'MyHeritage'),
        url: `/${i18n.language}/access/myheritage`,
        linkName: 'ff_thirdParty_myHeritage',
        isNew: false,
      },
      {
        id: 'findMyPast',
        text: t('nav.links.third-party-access.FindMyPast', 'FindMyPast'),
        url: `/${i18n.language}/access/findmypast`,
        linkName: 'ff_thirdParty_findMyPast',
        isNew: false,
      },
      {
        id: 'americanAncestors',
        text: t('nav.links.third-party-access.american-ancestors', 'American Ancestors'),
        url: `/${i18n.language}/access/americanancestors`,
        linkName: 'ff_thirdParty_americanAncestors',
        isNew: false,
        hidden: isNonEnCoreLanguage,
      },
      {
        id: 'filae',
        text: t('nav.links.third-party-access.filae', 'Filae'),
        url: `/${i18n.language}/access/filae`,
        linkName: 'ff_thirdParty_filae',
        isNew: false,
        hidden: !canSeeTemple,
      },
      {
        id: 'geneanet',
        text: t('nav.links.third-party-access.geneanet', 'Geneanet'),
        url: `/${i18n.language}/access/geneanet`,
        linkName: 'ff_thirdParty_geneanet',
        isNew: false,
      },
      {
        id: 'allThirdPartyLinks',
        text: t('nav.links.third-party-access.all-third-parties', 'All Third-parties'),
        url: `/${i18n.language}/access`,
        linkName: 'ff_thirdParty_allLinks',
        isNew: false,
      },
    ],
  }
}
